<template>
    <div id="searchResults" class="search-results-container" :class="{'quick-search': searchType === 'Smart'}">
        <div class="feature-area-wrapper">
            <div class="feature-area feature-area-compact">
                <searchResultsMenu />
                <navigationTabs />
            </div>
        </div>

        <div class="searchResults">
            <div class="adv-results-container" ref="resultsContainer">
                <facets class=""  ref="facets"/>
                <div class="content-with-sidebar" >
                    <div class="m-3" id="new-sections-container">
                        <div id="press-release" class="news-sections project-description">
                            <b-link
                                v-b-toggle="'news-collapse-press'"
                                @click="fixHeader($event, 'press-release')"
                                aria-controls="#news-collapse-press"
                                class="collapse-button section-header"
                                aria-expanded="true" rel="noopener">
                                    <i class="fas fa-angle-down collapse-icon"></i>
                                    <span class="header">Press Releases</span> <span class="count" v-if="newsCount.PressRelease && newsCount.PressRelease.total > 0">
                                        {{newsCount.PressRelease.total}}
                                        <template v-if="PressReleaseTable.isCountLoading"> and finding more <span  class="loading count"><div class="loader-bg"></div><span class="loader">Loading...</span></span></template>
                                        <template v-else>
                                            Press Release<template v-if="newsCount.PressRelease.total > 1">s</template> found.
                                        </template>
                                    </span>
                                    <span v-if="!newsCount.PressRelease && PressReleaseTable.isCountLoading" class="loading count"><div class="loader-bg"></div><span class="loader">Loading...</span></span>
                            </b-link>
                            <b-collapse :id="'news-collapse-press'" visible>
                                <span class="sub-note" v-if="newsCount.PressRelease && newsCount.PressRelease.totalCoreProjects > 0 && !PressReleaseTable.isCountLoading">There are {{newsCount.PressRelease.total}} new<template v-if="newsCount.PressRelease.total > 1">s</template> items citing {{newsCount.PressRelease.totalCoreProjects}} project<template v-if="newsCount.PressRelease.totalCoreProjects > 1">s</template>.</span>
                                <div class="data-section">
                                    <div v-if="!newsResults.PressRelease && PressReleaseTable.isLoading" class="loading"><div class="loader-bg"></div><span class="loader">Loading...</span></div>
                                    <dataTable containerScrolling="true" :noDataMessage="noNewsDataErrorMsg"  id="pressReleaseTable" class="dataTable" :table="PressReleaseTable" fromPage="PressRelease" ref="PressReleaseDataTable" v-if="newsResults.PressRelease"/>
                                    <div class="field-error-message error-large" v-if="serviceError">
                                        Unable to load Press Releases data
                                        <div class="error-code">
                                        {{serviceError}}
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                        <div id="research-matters" class="news-sections project-description" v-show="newsResults.ResearchMatters && newsResults.ResearchMatters.results && newsResults.ResearchMatters.results.length > 0">
                            <b-link
                                v-b-toggle="'news-collapse-research'"
                                @click="fixHeader($event, 'research-matters')"
                                aria-controls="#news-collapse-research"
                                class="collapse-button section-header"
                                aria-expanded="true" rel="noopener">
                                    <!-- <svgicon name="icon-arrow-down" class="collapse-icon" alt="" /> -->

                                    <i class="fas fa-angle-down collapse-icon"></i>

                                    <span class="header">Research Matters</span> <span class="count" v-if="newsCount.ResearchMatters && newsCount.ResearchMatters.total > 0">
                                        {{newsCount.ResearchMatters.total}}
                                        <template v-if="ResearchMattersTable.isCountLoading"> and finding more <span  class="loading count"><div class="loader-bg"></div><span class="loader">Loading...</span></span></template>
                                        <template v-else>
                                            <template v-if="newsCount.ResearchMatters.total > 1">Stories</template><template v-else>Story</template> found.
                                        </template>
                                    </span><span v-if="!newsCount.ResearchMatters && ResearchMattersTable.isCountLoading" class="loading count"><div class="loader-bg"></div><span class="loader">Loading...</span></span>
                            </b-link>
                            <b-collapse id="news-collapse-research" >
                                <span class="sub-note" v-if="newsCount.ResearchMatters && newsCount.ResearchMatters.totalCoreProjects > 0 && !ResearchMattersTable.isCountLoading">
                                    <template v-if="newsCount.ResearchMatters.total > 1">
                                        There are {{newsCount.ResearchMatters.total}} stories citing {{newsCount.ResearchMatters.totalCoreProjects}} project<template v-if="newsCount.ResearchMatters.totalCoreProjects > 1">s</template>.
                                    </template>
                                    <template v-else>
                                        There is {{newsCount.ResearchMatters.total}} story citing {{newsCount.ResearchMatters.totalCoreProjects}} project<template v-if="newsCount.ResearchMatters.totalCoreProjects > 1">s</template>.
                                    </template>
                                </span>
                                <div  class=" data-section ">
                                    <div v-if="!newsResults.ResearchMatters && ResearchMattersTable.isLoading" class="loading"><div class="loader-bg"></div><span class="loader">Loading...</span></div>
                                    <dataTable containerScrolling="true"  id="ResearchMattersTable" class="dataTable" :table="ResearchMattersTable" fromPage="ResearchMatters" ref="ResearchMattersDataTable" v-if="newsResults.ResearchMatters"/>
                                    <div class="field-error-message error-large" v-if="serviceError">
                                        Unable to load Research Matters data
                                        <div class="error-code">
                                        {{serviceError}}
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                        <div id="AIRS" class="news-sections project-description" v-show="newsResults.AIRS && newsResults.AIRS.results && newsResults.AIRS.results.length > 0">
                            <b-link
                                v-b-toggle="'AIRS-collapse-press'"
                                @click="fixHeader($event, 'AIRS')"
                                aria-controls="#AIRS-collapse-press"
                                class="collapse-button section-header"
                                aria-expanded="false" rel="noopener">
                                    <i class="fas fa-angle-down collapse-icon"></i>
                                    <span class="header">ARRA Investment Reports</span> <span class="count" v-if="newsCount.AIRS && newsCount.AIRS.total > 0">
                                        {{newsCount.AIRS.total}} NIH Recovery Act Investment Report<template v-if="newsCount.AIRS.total > 1">s</template> found.
                                    </span><span v-if="!newsCount.AIRS && AIRSTable.isCountLoading" class="loading count"><div class="loader-bg"></div><span class="loader">Loading...</span></span>
                            </b-link>
                            <b-collapse id="AIRS-collapse-press" >
                                <span class="sub-note" v-if="newsCount.AIRS && newsCount.AIRS.totalCoreProjects > 0">
                                    <template v-if="newsCount.AIRS.total > 1">
                                        There are {{newsCount.AIRS.total}} NIH Recovery Act Investment Reports citing {{newsCount.AIRS.totalCoreProjects}} project<template v-if="newsCount.AIRS.totalCoreProjects > 1">s</template>.
                                    </template>
                                    <template v-else>
                                        There is {{newsCount.AIRS.total}} NIH Recovery Act Investment Report citing {{newsCount.AIRS.totalCoreProjects}} project<template v-if="newsCount.AIRS.totalCoreProjects > 1">s</template>.
                                    </template>
                                </span>
                                <div  class=" data-section ">
                                    <div v-if="!AIRSTable && AIRSTable.isLoading" class="loading"><div class="loader-bg"></div><span class="loader">Loading...</span></div>
                                    <dataTable containerScrolling="true"  id="AIRSTable" class="dataTable" :table="AIRSTable" fromPage="AIRS" ref="AIRSDataTable" v-if="newsResults.AIRS" />

                                </div>
                            </b-collapse>
                        </div>
                        <div id="ARRA" class="news-sections project-description" v-show="newsResults.ARRA && newsResults.ARRA.results && newsResults.ARRA.results.length > 0">
                            <b-link
                                v-b-toggle="'ARRA-collapse-press'"
                                @click="fixHeader($event, 'ARRA')"
                                aria-controls="#ARRA-collapse-press"
                                class="collapse-button section-header"
                                aria-expanded="false" rel="noopener">
                                    <i class="fas fa-angle-down collapse-icon"></i>
                                    <span class="header">ARRA Stories</span> <span class="count" v-if="newsCount.ARRA && newsCount.ARRA.total > 0">
                                        {{newsCount.ARRA.total}} NIH Recovery Stor<template v-if="newsCount.ARRA.total > 1">ies</template><template v-else>y</template> found.
                                    </span><span v-if="!newsCount.ARRA && ARRATable.isCountLoading" class="loading count"><div class="loader-bg"></div><span class="loader">Loading...</span></span>
                            </b-link>
                            <b-collapse id="ARRA-collapse-press">
                                <span class="sub-note" v-if="newsCount.ARRA && newsCount.ARRA.totalCoreProjects > 0">
                                    <template v-if="newsCount.ARRA.total > 1">
                                        There are {{newsCount.ARRA.total}} NIH Recovery Stories citing {{newsCount.ARRA.totalCoreProjects}} project<template v-if="newsCount.ARRA.totalCoreProjects > 1">s</template>.
                                    </template>
                                    <template v-else>
                                        There is {{newsCount.ARRA.total}} NIH Recovery Story citing {{newsCount.ARRA.totalCoreProjects}} project<template v-if="newsCount.ARRA.totalCoreProjects > 1">s</template>.
                                    </template>
                                </span>
                                <div  class=" data-section ">
                                    <div v-if="!ARRATable && ARRATable.isLoading" class="loading"><div class="loader-bg"></div><span class="loader">Loading...</span></div>
                                    <dataTable containerScrolling="true"  id="ARRATable" class="dataTable" :table="ARRATable" fromPage="ARRA" ref="ARRADataTable" v-if="newsResults.ARRA" />

                                </div>
                            </b-collapse>
                        </div>
                        <div id="AIMRS" class="news-sections project-description" v-show="newsResults.AIMRS && newsResults.AIMRS.results.length > 0">
                            <b-link
                                v-b-toggle="'AIMRS-collapse-press'"
                                @click="fixHeader($event, 'AIMRS')"
                                aria-controls="#AIMRS-collapse-press"
                                class="collapse-button section-header"
                                aria-expanded="false" rel="noopener">
                                    <i class="fas fa-angle-down collapse-icon"></i>
                                    <span class="header">ARRA Impact Reports</span> <span class="count" v-if="newsCount.AIMRS && newsCount.AIMRS.total > 0">
                                        {{newsCount.AIMRS.total}} NIH ARRA Impact Report<template v-if="newsCount.AIMRS.total > 1">s</template> found.
                                    </span><span v-if="!newsCount.AIMRS && AIMRSTable.isCountLoading" class="loading count"><div class="loader-bg"></div><span class="loader">Loading...</span></span>
                            </b-link>
                            <b-collapse id="AIMRS-collapse-press">
                                <span class="sub-note" v-if="newsCount.AIMRS && newsCount.AIMRS.totalCoreProjects > 0">
                                    <template v-if="newsCount.AIMRS.total > 1">
                                        There are {{newsCount.AIMRS.total}} NIH ARRA Impact Reports citing {{newsCount.AIMRS.totalCoreProjects}} project<template v-if="newsCount.AIMRS.totalCoreProjects > 1">s</template>.
                                    </template>
                                    <template v-else>
                                        There is {{newsCount.AIMRS.total}} NIH ARRA Impact Report citing {{newsCount.AIMRS.totalCoreProjects}} project<template v-if="newsCount.AIMRS.totalCoreProjects > 1">s</template>.
                                    </template>
                                </span>
                                <div  class=" data-section ">
                                    <div v-if="!AIMRSTable && AIMRSTable.isLoading" class="loading"><div class="loader-bg"></div><span class="loader">Loading...</span></div>
                                    <dataTable containerScrolling="true"  id="AIMRSTable" class="dataTable" :table="AIMRSTable" fromPage="AIMRS" ref="AIMRSDataTable" v-if="newsResults.AIMRS" />

                                </div>
                            </b-collapse>
                        </div>

                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import dataTable from '@/components/global/dataTable.vue';
import navigationTabs from '@/components/global/navigationTabs.vue';
import facets from '@/components/global/facets.vue';
import searchResultsMenu from '@/components/global/searchResultsMenu.vue';
import globalMixins from '@/globalMixins';
import projectListMixins from '@/projectListMixins';
import exportModule from  '@/components/global/export.vue';
import bus from '@/shared/event-bus.js';

export default {
    name: 'News',
    mixins: [globalMixins, projectListMixins],
    components: {
      dataTable,
      navigationTabs,
      facets,
      searchResultsMenu,
      exportModule
    },
    computed: {
        ...mapGetters([
            'searchCriteria',
            'editSearchCriteria',
            'searchMeta',
            'newsResults',
            'newsCount',
            'externalURLs'
        ]),
    },
    data: function () {
        return {
            serverless: false,
            data: null,
            serviceError: null,
            noNewsDataErrorMsg: 'No news release information available',
            isSortRequested: {
                PressRelease: false,
                ResearchMatters: false
            }
        };
    },
    mounted () {
        if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
            this.$router.push({ path: '/' }).catch(err => {});
        } else {
            this.showCriteria = false;
            if (!this.newsResults.PressRelease) {
                this.PressReleaseTable.isLoading = true;
                if (this.$route.query) {
                    this.parseFacetFiltersFromURL();
                }
                this.getAllNewsData(false);
            }
        }

        this.setFullscreen(true);
        setTimeout(() => {
            bus.$emit('update:resize');
        }, 1);
    },
    methods: {
        ...mapActions([
            'setFullscreen',
            'setEditSearchResultsFlag',
            'setLookup',
            'setSearchMode',
            'setNewsResults',
            'updateNewsResults',
            'updateMetaNewsResults',
            'setNewsCount'
        ]),
        setSortDetails ($event, selectedSortColumn) {
            var curSelected = window.closest($event.target, '.project-description'),
                dbSortField = this.getFieldNameFromSettings(selectedSortColumn),
                selectedSortField = selectedSortColumn.subField ? selectedSortColumn.fieldName + '[0].' + selectedSortColumn.subField : selectedSortColumn.fieldName,
                tableContainer,
                sortedData,
                self = this,
                selectedSectionId = curSelected.getAttribute('id');

            if (curSelected) {
                var sectionName = selectedSectionId === 'press-release' ? 'PressRelease' : (selectedSectionId === 'research-matters' ? 'ResearchMatters' : selectedSectionId),
                    tableName = sectionName + 'Table',
                    dataTableName= sectionName + 'DataTable';

                tableContainer = window.closest($event.target, '.data-section');
                tableContainer.scrollTop = 0;
                if (this[tableName].sortField === dbSortField) {
                    this[tableName].sortOrder = (this[tableName].sortOrder === 'asc' ? 'desc' : 'asc');
                } else {
                    this[tableName].sortOrder = selectedSortColumn.sortOrder;
                }

                this[tableName].sortField = dbSortField;
                this[tableName].offset = 0;
                if (this.$store.state.newsResults[sectionName].meta.properties) {
                    this.$store.state.newsResults[sectionName].meta.properties.lastItem = null;
                }

                self.getNewsData(sectionName, self.handleNewsData);
            }
        },
        getAllNewsData () {
            this.PressReleaseTable.sortField = null;
            this.PressReleaseTable.sortOrder = "desc";
            this.PressReleaseTable.isLoading = true;
            this.PressReleaseTable.offset = 0;
            this.PressReleaseTable.isCountLoading = true;
            this.getNewsData('PressRelease', this.handleNewsData);

            this.ResearchMattersTable.sortField = null;
            this.ResearchMattersTable.sortOrder = "desc";
            this.ResearchMattersTable.isLoading = true;
            this.ResearchMattersTable.offset = 0;
            this.ResearchMattersTable.isCountLoading = true;
            this.getNewsData('ResearchMatters', this.handleNewsData);

            this.AIRSTable.isLoading = true;
            this.AIRSTable.offset = 0;
            this.AIRSTable.isCountLoading = true;
            this.getNewsData('AIRS', this.handleNewsData);

            this.ARRATable.isLoading = true;
            this.ARRATable.offset = 0;
            this.ARRATable.isCountLoading = true;
            this.getNewsData('ARRA', this.handleNewsData);

            this.AIMRSTable.isLoading = true;
            this.AIMRSTable.offset = 0;
            this.AIMRSTable.isCountLoading = true;
            this.getNewsData('AIMRS', this.handleNewsData);
        },
        setProjectPageNumber (newsType) {
            var curTableName = newsType + 'Table',
                curTableRefName = newsType + 'DataTable';

            this[curTableName].loadingMoreData = true;
            this[curTableName].offset += this[curTableName].limit;
            this.getNewsData(newsType, this.handleNewsData);
        },
        fixHeader (e, containerId) {
            setTimeout(() => {
                if (!e.target.classList.contains('collapsed')) {
                    window.sizeTableHeader(containerId);

					var sectionName,
                        dataTableName;

                    switch (containerId) {
                        case 'press-release':
                        case 'research-matters':
                            sectionName = containerId === 'press-release' ? 'PressRelease' : 'ResearchMatters';
                            dataTableName= sectionName + 'DataTable';
                            if (this.$refs[dataTableName]) {
                                this.$refs[dataTableName].tableScrolling();
                            }
                            break;
                        default:
                            dataTableName= containerId + 'DataTable';
                            this.$refs[dataTableName].fixSubPageTableHeaders();
                    }
                }
            }, 101);

        },
        handleNewsData (data, newsType) {
            var curTableName = newsType + 'Table',
                curTableRefName = newsType + 'DataTable',
                sortField = "date_added",
                sortOrder = "desc";

            if (this[curTableName]) {
                this[curTableName].isLoading = false;
                this[curTableName].loadingMoreData = false;
                sortField = this[curTableName].sortField ? this[curTableName].sortField : "date_added";
                sortOrder = this[curTableName].sortOrder ? this[curTableName].sortOrder : "desc";
            }

            if (!data || (data && data.status && data.status !== 200)) {
                this[newsType + 'Table'].isCountLoading = false;
                this.setNewsResults({
                    name: newsType,
                    data: null
                });
                this.serviceError = this.externalURLs.reporter_project_search_error_message;

                return false;
            } else {
                if (data && data.results && data.results.length > 0) {
                    if(this[curTableName].offset === 0) {
                        let sortedData = _.orderBy(data.results, [
                            function (item) {
                                return item[sortField];
                            }
                        ], [sortOrder]);

                        this.setNewsResults({
                            name: newsType,
                            data: {
                                meta: data.meta,
                                results: sortedData
                            }
                        });
                    } else {
                        this.updateNewsResults({
                            name: newsType,
                            data: data
                        });

                        let sortedData = _.orderBy(this.$store.state.newsResults[newsType].results, [
                            function (item) { return item[sortField]; }
                        ], [sortOrder]);

                        this.setNewsResults({
                            name: newsType,
                            data: {
                                meta: this.$store.state.newsResults[newsType].meta,
                                results: sortedData
                            }
                        });
                    }
                    if (!this.$store.state.newsCount[newsType] || Object.keys(this.$store.state.newsCount[newsType]).length === 0) {
                        if (data.meta.properties.lastItem) {
                            if (newsType === 'PressRelease' || newsType === 'ResearchMatters') {
                                this.setNewsCount({
                                    name: newsType,
                                    data: {
                                        meta: data.meta,
                                        results: [data.results.length]
                                    }
                                });
                            }
                            this.getNewsCount(newsType, this.handleNewsCount);
                        } else {
                            this[newsType + 'Table'].isCountLoading = false;
                            let uniGrantNumArray = _.map(_.uniqBy(data.results, 'grant_num'), function (item) {
                                return {
                                grant_num: item.grant_num
                                };
                            });
                            data.meta.total = uniGrantNumArray.length;
                            this.setNewsCount({
                                name: newsType,
                                data: {
                                    meta: data.meta,
                                    results: [data.results.length]
                                }
                            });
                        }
                    }
                } else {
                    this[newsType + 'Table'].isCountLoading = false;
                    if(this[curTableName].offset === 0) {
                        this.setNewsResults({
                            name: newsType,
                            data: data
                        });
                    } else {
                        this.updateMetaNewsResults({
                            name: newsType,
                            data: data
                        });
                    }
                }
                if (this.$store.state.newsResults[newsType] && this.$store.state.newsResults[newsType].results && this.$store.state.newsResults[newsType].results.length === 0) {
                    if (window.newsCountXHR[newsType]) {
                        window.newsCountXHR[newsType].abort();
                    }
                    this.setNewsCount({
                        name: newsType,
                        data: 0
                    });
                }
                if (this.$refs && this.$refs[curTableRefName]) {
                    this.$refs[curTableRefName].initTableData ();
                }
            }
        },
        handleNewsCount (data, newsType) {
            if (this[newsType + 'Table']) {
                this[newsType + 'Table'].isCountLoading = false;
            }
            if (data && data.meta) {
                if (data.results.length > 0 && data.results[0] !== 0) {
                    this.setNewsCount({
                        name: newsType,
                        data: data
                    });

                    if (data.meta.properties && data.meta.properties.lastItem  && data.meta.properties.lastItem !== null && (newsType === 'PressRelease' || newsType === 'ResearchMatters')) {
                        this[newsType + 'Table'].isCountLoading = true;
                        this.getNewsCount(newsType, this.handleNewsCount);
                    }
                }
            }
        },
        scrollToResultsTop () {
            let resultsOffsetTop = this.getResultsContainerOffsetTop();

            // only scroll up if user view is scrolled below top of table
            if (window.pageYOffset > resultsOffsetTop) {
                window.scrollTo(0, this.getResultsContainerOffsetTop());
            }
        },
        getResultsContainerOffsetTop () {
            return this.$refs.resultsContainer ? this.$refs.resultsContainer.offsetTop : 0;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
.news-sections {
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
    border-radius: 15px;
    background-color: #fff;
    margin: 15px 15px 15px 10px;
    width:calc(100% - 25px) !important;
    .section-header {
        padding: 15px;
        display: block;
        font-size: 20px;
        position: relative;
        color: #015496;
        cursor: pointer;
        transition: 0.3s;
        text-decoration: none;
        .header {
            font-weight: bold;
            display: inline-block;
            margin-right: 11px;
            font-size: 1.1em;
        }
        .count {
            font-size: 13px;
        }

        .collapse-icon {
            top: calc(50% - 0.4em);
            margin-right: 10px;
            width: 18px;
            height: 18px;
            fill: $facets-arrow-color;
            transition: 0.3s;
        }

        &:hover, &:focus {
            text-decoration: none;
            .header {
                color: #00294a;
                text-decoration: none;
            }
            .count {
                text-decoration: none;
            }
        }

        &.collapsed {
            border-color: transparent;
            .collapse-icon {
                transform: rotate(-90deg);
            }
        }
    }
    .sub-note {
        display: block;
        padding: 5px;
        font-size: 13px;
        font-weight: 700;
        color: $grey-med;
        border-top: 1px solid rgba(0, 0, 0, 0.2)
    }
    .data-section {
        margin:10px;
        padding: 0 0 15px;
        max-height: 500px;
        height: 100%;
        min-height: 200px;
        position:relative;
        overflow: auto;

        &.show {
            overflow: auto;
        }
    }


    .loading {
        bottom: 15px;
        .loader {
            top: 80px;
        }

        &.count {
            position: relative;
            display: inline-block;
            width: 25px;
            .loader {
                top: 0 !important;
                left: 25%;
                height: 20px;
                width: 20px;
            }
        }
    }
}
</style>